module.exports = __webpack_public_path__ + "static/media/book5.ecceada9.jpg";